import services from "@/http";
import * as types from "./mutation-types";
import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty";
import jsonToFormData from "@/helpers/functions/jsonToFormData";
import { default_image_data } from "@/components/Form/Imagem.vue";
import { merge } from "lodash";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetConcedentes", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var concedentes = {
    data: [],
    meta: {},
  };

  await services.concedentes.get_all(search).then((res) => {
    concedentes = res.data;
  });
  return concedentes;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.concedentes.show({ id: id }).then((res) => {
    dispatch("ActionSetConcedente", res.data.concedente);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.concedentes.store(payload).then((res) => {
    commit(types.SET_CONCEDENTE, res.data.concedente);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.concedentes.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_CONCEDENTE, res.data.concedente);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.concedentes.delete({ id: id }).then(() => {
    commit(types.SET_CONCEDENTE, null);
  });
};

export const ActionSetConcedentes = ({ commit }, payload) => {
  commit(types.SET_CONCEDENTES, payload);
};

export const ActionSetConcedente = ({ commit }, payload) => {
  if (typeof payload.imagem !== "object") {
    payload.imagem = default_image_data;
  }

  commit(types.SET_CONCEDENTE, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNew = ({ commit, getters }) => {
  let concedente = {
    concedente_tipo_id: null,
    nome: "",
    sobre: "",
    sem_endereco: false,
    endereco: endereco_empty(),
    contatos: contatos_empty(),
    imagem: default_image_data,
  };
  commit(types.SET_CONCEDENTE, concedente);
};

export const ActionVerifyNome = async (store, payload) => {
  var concedentes = [];

  if (payload.nome) {
    await services.concedentes.verify_nome(payload).then(({ data }) => {
      concedentes = data;
    });
  }
  return concedentes;
};
